import { initialState } from "./state"

export default {
  setCep: (state, payload) => (state.cep = payload),
  setStreet: (state, payload) => (state.street = payload),
  setNumber: (state, payload) => (state.number = payload),
  setNoNumber: (state, payload) => (state.noNumber = payload),
  setNeighborhood: (state, payload) => (state.neighborhood = payload),
  setState: (state, payload) => (state.state = payload),
  setCity: (state, payload) => (state.city = payload),
  setCityName: (state, payload) => (state.cityName = payload),
  setAllAddress: (state, payload) => {
    Object.keys(payload).forEach(key => {
      state[key] = payload[key]
    })
  },
  setComplements: (state, payload) => (state.complements = payload),
  setLatitude: (state, payload) => (state.latitude = payload),
  setLongitude: (state, payload) => (state.longitude = payload),
  setCoverageStatus: (state, payload) => (state.coverageStatus = payload),
  setAvailableBoxes: (state, payload) => (state.availableBoxes = payload),
  setCto: (state, payload) => (state.cto = payload),
  resetAddress: state => {
    const INITIAL_STATE = initialState()
    Object.keys(state).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  },
  setCurrentLatitude: (state, payload) => (state.currentLatitude = payload),
  setCurrentLongitude: (state, payload) => (state.currentLongitude = payload),
  setCepForCurrentLocation: (state, payload) =>
    (state.cepFromCurrentLocation = payload),
  setHasMadeCepFromCurrentLocationRequest: (state, payload) =>
    (state.hasMadeCepFromCurrentLocationRequest = payload),
  setLocationType: (state, payload) => state.locationType = payload
}
